import { ConfirmModal as BlublocksConfirmModal } from "@bluframe/blublocks"
import Typography from "components/Typography"
import { JSX } from "react"

import { ComponentProps } from "."
import { TitleWrapper } from "./styled"

/**
 * ConfirmModal
 *
 * @description
 * Wraps the blublocks ConfirmModal to optionally render a title above the message with responsive spacing.
 * @param {ComponentProps} props - Confirm modal configuration including optional title.
 * @returns {JSX.Element} The rendered ConfirmModal component.
 *
 */
const ConfirmModal = ({
  title,
  message,
  ...rest
}: ComponentProps): JSX.Element => {
  let modalMessage = message

  if (title) {
    modalMessage = (
      <TitleWrapper>
        <Typography.H5>{title}</Typography.H5>

        {message}
      </TitleWrapper>
    )
  }

  return <BlublocksConfirmModal message={modalMessage} {...rest} />
}

export default ConfirmModal
